import { IconChevronExpandYOutline18 as ExpandableIcon } from "nucleo-ui-outline-18"

import type {} from "@productlane/lib/src/tiptap/extensions/mintlify/expandable"

import type { SlashCommandDefinition } from "../../types"
import { iconClassName } from "../../constants"

export const expandableCommand: SlashCommandDefinition = {
	key: "expandable",
	title: "Expandable",
	icon: <ExpandableIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertExpandable().run()
	},
	group: "blocks",
	aliases: [
		"expandable",
		"nested",
		"properties",
		"child fields",
		"object",
		"show properties",
	],
}
